import {
    downloadSolutionsGeneralReports,
    downloadSolutionsSummaryReports,
    getSolutionsReports,
} from '@/api/solutionsReportsApi.js';
import { downloadUrl } from '@/api/attachmentsApi.js';
import useSnackbar from '@/hooks/snackbars.js';
import router from '@/router/index.js';
import { getEchoInstance } from '@/services/echo.js';

const { createSnackbar } = useSnackbar();

/**
 * @param {AxiosResponse} response
 * @param {string} [errorMsg]
 */
const throwIfNotSuccess = (response, errorMsg = 'Ошибка') => {
    if (response?.data?.success === false) {
        throw new Error(errorMsg);
    }
};

export const startSolutionsSummaryReport = async versionId => {
    try {
        const resp = await downloadSolutionsSummaryReports(versionId);
        const { developmentCenterId } = router.currentRoute.value.params;

        throwIfNotSuccess(resp, 'Ошибка старта формирования отчета');
        createSnackbar({
            type: 'info',
            size: 'large',
            title: 'Фомирование отчета',
            message: 'Сводный отчет поставлен в очередь на создание. Сформированный отчет можно будет получить на странице отчетов.',
            link: {
                text: 'Перейти к списку отчетов',
                route: {
                    name: 'AdminReports',
                    params: {
                        developmentCenterId,
                    },
                },
            },
        });
    } catch (e) {
        console.error(e);
        createSnackbar({
            type: 'error',
            message: 'Ошибка формирование отчета',
        });
    }
};


export const startSolutionsGeneralReport = async versionId => {
    try {
        const resp = await downloadSolutionsGeneralReports(versionId);
        const { developmentCenterId } = router.currentRoute.value.params;

        throwIfNotSuccess(resp, 'Ошибка старта формирования отчета');
        createSnackbar({
            type: 'info',
            size: 'large',
            title: 'Фомирование отчета',
            message: 'Отчет по ученикам поставлен в очередь на создание. Сформированный отчет можно будет получить на странице отчетов.',
            link: {
                text: 'Перейти к списку отчетов',
                route: {
                    name: 'AdminReports',
                    params: {
                        developmentCenterId,
                    },
                },
            },
        });
    } catch (e) {
        console.error(e);
        createSnackbar({
            type: 'error',
            message: 'Ошибка формирование отчета',
        });
    }
};

export default /** @type {import('vuex').Module<any, any>} */ ({
    namespaced: true,
    state: {
        fetched: false,
        loading: false,
        reports: [],
    },
    mutations: {
        startLoading(state) {
            state.loading = true;
        },
        stopLoading(state) {
            state.loading = false;
            state.fetched = true;
        },
        saveReports(state, { reports }) {
            state.reports = reports;
        },
    },
    actions: {
        initReportChanel({ dispatch }, { userId }) {
            getEchoInstance()
                .private(`users.${userId}.report`)
                .stopListening('.report.ready')
                .listen('.report.ready', reportData => {
                    const { developmentCenterId } = router.currentRoute.value.params;

                    createSnackbar({
                        type: 'success',
                        size: 'large',
                        title: 'Отчет сформирован',
                        message: 'Чтобы скачать отчет перейдите на страницу списка отчетов.',
                        link: {
                            text: 'Перейти к списку отчетов',
                            route: {
                                name: 'AdminReports',
                                params: {
                                    developmentCenterId,
                                },
                            },
                        },
                        actionButton: {
                            text: 'Скачать отчет',
                            iconName: 'download',
                            on: {
                                click: () => {
                                    if (reportData.url) {
                                        downloadUrl(reportData.url);
                                    }
                                },
                            },
                        },
                    });

                    if (router.currentRoute.value.name === 'AdminReports') {
                        dispatch('getReports');
                    }
                })
                .stopListening('.report.failed')
                .listen('.report.failed', () => {
                    createSnackbar({
                        type: 'error',
                        size: 'large',
                        title: 'Ошибка формирования отчет',
                    });
                });
        },
        async getReports({ commit }) {
            try {

                commit('startLoading');

                const resp = await getSolutionsReports();

                commit('saveReports', { reports: resp.data.data });
            } catch (e) {
                console.error(e);
                this.createSnackbar({
                    type: 'error',
                    message: 'Ошибка получаения списка отчетов',
                });
            } finally {
                commit('stopLoading');
            }
        },
    },
});
